import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { notifyError, notifySuccess } from "./notification.slice";
import { authFailCheck } from "./auth.slice";
import CategoryService from "./../services/CategoryService";
import { createSelector } from "reselect";

const categoryAdapter = createEntityAdapter({
  selectId: (category) => category.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

const categorySlice = createSlice({
  name: "categories",
  initialState: categoryAdapter.getInitialState({
    prices: {},
    isLoading: false,
  }),
  reducers: {
    fetchRequest(state) {
      state.isLoading = true;
    },
    fetchFail(state, action) {
      state.isLoading = false;
    },
    fetchCategoriesSuccess(state, action) {
      const { payload } = action;
      state.isLoading = false;
      categoryAdapter.setAll(state, payload);
    },
    updateCategorySuccess(state, action) {
      const { payload } = action;
      state.isLoading = false;
      categoryAdapter.upsertOne(state, payload);
    },
    fetchActivePricesSuccess(state, action) {
      const { payload } = action;
      state.isLoading = false;
      payload.forEach((cat) => {
        state.prices[cat.id] = cat.prices;
      });
    },
  },
});

export default categorySlice.reducer;

export const categorySelectors = categoryAdapter.getSelectors((state) => state.categories);

export const activeCategoriesSelector = createSelector(
  [categorySelectors.selectAll],
  (categories) => categories.filter((x) => x.isActive)
);

export const {
  fetchRequest,
  fetchFail,
  fetchCategoriesSuccess,
  updateCategorySuccess,
  fetchActivePricesSuccess,
} = categorySlice.actions;

export const fetchCategories = () => async (dispatch) => {
  dispatch(fetchRequest());

  const response = await CategoryService.get();
  if (response.ok) {
    dispatch(fetchCategoriesSuccess(response.data));
  } else {
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};

export const switchCategory = (categoryId) => async (dispatch, getState) => {
  dispatch(fetchRequest());

  const category = categorySelectors.selectById(getState(), categoryId);
  let message;

  if (!category.isActive) {
    message = `${category.name} yoqildi.`;
  } else {
    message = `${category.name} o'chirildi.`;
  }

  const response = await CategoryService.switch(categoryId);

  if (response.ok) {
    dispatch(notifySuccess(message));
    dispatch(updateCategorySuccess({ ...category, isActive: !category.isActive }));
  } else {
    dispatch(authFailCheck(response));
    dispatch(notifyError("Kategoriyani o'chirib yoqishda xatolik."));
    dispatch(fetchFail(response.data));
  }
};

export const updateCategoryPrice = (categoryId, data) => async (dispatch, getState) => {
  dispatch(fetchRequest());

  const category = categorySelectors.selectById(getState(), categoryId);
  let message = `${category.name} narxi o'zgartirildi`;

  const response = await CategoryService.updatePrice(categoryId, data);

  if (response.ok) {
    dispatch(notifySuccess(message));
    dispatch(updateCategorySuccess({ ...category, price: data.price }));
  } else {
    dispatch(authFailCheck(response));
    dispatch(notifyError("Kategoiyani narxi o'zgartirishda xatolik."));
    dispatch(fetchFail(response.data));
  }
};

export const fetchActivePrices = () => async (dispatch) => {
  dispatch(fetchRequest());

  const response = await CategoryService.getActivePrices();
  if (response.ok) {
    dispatch(fetchActivePricesSuccess(response.data));
  } else {
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};
